module.exports = __webpack_public_path__ + "img/doubleChevron.6b5a10e8.svg";